export const aboutContent = {
    fr: {
        eyebrow: 'POURQUOI NOUS CHOISIR',
        title: 'Un service pensé pour tout regarder, sans limite.',
        featuredTitle: '79 000+ chaînes du monde',
        featuredBody: 'Accédez à 79 000 chaînes TV et 249 000 films et séries, y compris une large sélection de chaînes européennes.',
        tags: ['Sport en direct', 'Films & séries', 'Chaînes premium'],
        tiles: [
            { title: 'Garantie de remboursement', body: 'Pas satisfait ? Remboursement intégral sous 15 jours, sans condition.' },
            { title: 'Installation instantanée', body: "Sur n'importe quel appareil, avec l'IBO Pro Player activé gratuitement." },
            { title: 'Connexion ultra-rapide', body: 'Serveurs européens dédiés : les chaînes chargent en moins de 0,5 seconde, sans coupure.' },
        ],
    },
    es: {
        eyebrow: 'POR QUÉ ELEGIRNOS',
        title: 'Un servicio pensado para verlo todo, sin límites.',
        featuredTitle: '+79.000 canales del mundo',
        featuredBody: 'Accede a 79.000 canales de TV y 249.000 películas y series, incluida una amplia selección de canales europeos.',
        tags: ['Deporte en directo', 'Películas y series', 'Canales premium'],
        tiles: [
            { title: 'Garantía de reembolso', body: '¿No estás satisfecho? Reembolso íntegro en 15 días, sin condiciones.' },
            { title: 'Instalación instantánea', body: 'En cualquier dispositivo, con el reproductor IBO Pro activado gratis.' },
            { title: 'Conexión ultrarrápida', body: 'Servidores europeos dedicados: los canales cargan en menos de 0,5 segundos, sin cortes.' },
        ],
    },
};
